import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { BadgeModule } from '../badge/badge.module';
import { CardNotificationComponent } from './card-notification.component';

@NgModule({
  declarations: [CardNotificationComponent],
  exports: [CardNotificationComponent],
  entryComponents: [CardNotificationComponent],
  imports: [CommonModule, AngularSvgIconModule, BadgeModule]
})
export class CardNotificationModule {}

export { CardNotificationComponent };
